import { render, staticRenderFns } from "./HelpTable.vue?vue&type=template&id=20b2c262&scoped=true"
import script from "./HelpTable.vue?vue&type=script&lang=ts"
export * from "./HelpTable.vue?vue&type=script&lang=ts"
import style0 from "./HelpTable.vue?vue&type=style&index=0&id=20b2c262&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b2c262",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20b2c262')) {
      api.createRecord('20b2c262', component.options)
    } else {
      api.reload('20b2c262', component.options)
    }
    module.hot.accept("./HelpTable.vue?vue&type=template&id=20b2c262&scoped=true", function () {
      api.rerender('20b2c262', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Help/Components/HelpTable.vue"
export default component.exports